/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Features_Color_DescInputs */

const en_fc_home_features_color_desc = /** @type {(inputs: Fc_Home_Features_Color_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Curves, color wheels, HSL secondaries, LUTs, HDR and log workflows. Waveform and vectorscope sit next to the image while you grade.`)
};

/**
* | output |
* | --- |
* | "Curves, color wheels, HSL secondaries, LUTs, HDR and log workflows. Waveform and vectorscope sit next to the image while you grade." |
*
* @param {Fc_Home_Features_Color_DescInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_features_color_desc = /** @type {((inputs?: Fc_Home_Features_Color_DescInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Features_Color_DescInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_features_color_desc(inputs)
});
export { fc_home_features_color_desc as "fc.home.features.color.desc" }